module.exports = {"values":["Acid","Cold","Fire","Force","Lightning","Necrotic","Poison","Psychic","Radiant","Thunder"]}


//////////////////
// WEBPACK FOOTER
// ./src/item-helpers/DamageTypes.json
// module id = 547
// module chunks = 0